export default __webpack_public_path__ + "static/media/eer.7a6be95b.svg";